import React from "react";
import { Star, Check, Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceHighlight() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const benefits = [];
  return <section data-section-id="12376" id="herobanner" ref={ref} className="relative overflow-hidden bg-background transition-opacity duration-700 opacity-100 !h-[850px] ![padding:10px_0px_0px_0px]">
      
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="flex flex-col text-left space-y-8 order-2 !justify-center !items-center lg:order-1">
            {}
            

            {}
            <h1 className="text-4xl font-black text-foreground leading-[1.1] tracking-tight !text-center !m-0 md:text-5xl lg:text-6xl">Win The Offer &amp; Protect Yourself</h1>

            {}
            <div className="flex items-center gap-3 text-muted-foreground">
              
              
            </div>

            {}
            <p className="text-muted-foreground leading-relaxed max-w-xl !m-0 !text-xl">Book an Independent Home Inspection and Receive a Clear Go / No-Go Summary - So You Know the Risks Before You Go Firm.&nbsp;</p>

            {}
            <ul className="space-y-4 w-full">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <div className="mt-1 flex-shrink-0 rounded-full bg-primary/10 p-1">
                    <Check className="w-4 h-4 text-primary" strokeWidth={3} />
                  </div>
                  <span className="text-foreground font-medium">Strate</span>
                </li>)}
            </ul>

            {}
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-base font-bold bg-gradient-to-br from-primary to-primary/80 text-primary-foreground hover:opacity-90 hover:-translate-y-1 transition-all duration-300 border-none rounded-lg">
                <Link to="/ContactPage">Book Your Inspection&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 w-5 h-5" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/ServiceHighlight.tsx|sig:cqcyhu" data-ast-start="2572" data-ast-end="2611"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base font-bold border-2 border-secondary text-secondary bg-transparent hover:bg-secondary hover:text-white transition-all duration-300 rounded-lg">
                <Link to="/AboutMePage">Why Choose Me</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative group order-1 lg:order-2">
            {}
            <div className="absolute -inset-4 bg-primary/10 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            
            <div className="relative rounded-xl overflow-hidden bg-muted">
              <img src="https://joewestinspections.com/wp-content/uploads/2026/03/Joe-PNG.png" alt="Professional Home Inspection Summary" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0">
        <Separator className="bg-border h-[1px]" />
      </div>
    </section>;
}